import RegiaoService from '@/services/RegiaoService';

export const regiao = {
    namespaced: true,
    actions: {
        buscarSingularidades( { dispatch } ) {
            return RegiaoService.buscarSingularidadesPorSub()
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        }
    },
    state: {},
    mutations: {},
};
